export enum FeatureFlags {
  ContentLibraryRouteEnabled = 44839,
}

export enum FeatureFlags_V2 {
  ReviewsInFileLibrary = 'REVIEWS_IN_FILE_LIBRARY',
  FileLibraryBaseplate = 'FILE_LIBRARY_BASEPLATE',
  FileLibraryNewToolbar = 'FILE_LIBRARY_NEW_TOOLBAR',
  FileLibraryCuff = 'ENABLE_FILE_LIBRARY_CUFF',
  FileApprovalStatusInContentView = 'FILE_APPROVAL_STATUS_IN_CONTENT_VIEW',
}

export enum EAPFeatureFlags_V2 {
  EAPContentLibraryEnabled = 'EAP_CONTENT_LIBRARY_IN_WORKSPACES',
}
